<template>
  <modal
    :show="isVisible"
    :title="t('Ajuste manual de créditos')"
    elem-id="modal_staff_credits_adjust"
    size="compactDesktop"
    :close-label="t('Cancelar')"
    :save-label="t('Aplicar ajuste')"
    :save-fn="handleSave"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <template v-if="isVisible">
      <manual-adjustment-form
        ref="formRef"
        @submit-success="handleSubmitSuccess"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../../eventBus';
import { log } from '../../../utils/DebugLogger';
import ManualAdjustmentForm from './ManualAdjustmentForm.vue';

const { t } = useI18n();

const isVisible = ref(false);
const formRef = ref<InstanceType<typeof ManualAdjustmentForm> | null>(null);

function handleOpen(): void {
  log('ManualAdjustmentModal', 'handleOpen', 'Opening manual adjustment modal');
  isVisible.value = true;
}

function handleClose(): void {
  log('ManualAdjustmentModal', 'handleClose', 'Closing manual adjustment modal');
  isVisible.value = false;
}

async function handleSave(): Promise<void> {
  log('ManualAdjustmentModal', 'handleSave', 'Triggering form submit');
  await formRef.value?.handleSubmit();
}

function handleSubmitSuccess(): void {
  log('ManualAdjustmentModal', 'handleSubmitSuccess', 'Adjustment saved, closing modal');
  eventBus.emit('staffCreditsAdjust.saved');
  eventBus.emit('staff-credits.refresh');
  eventBus.emit('globalMessage.success', t('Ajuste aplicado com sucesso'));
  handleClose();
}

onMounted(() => {
  log('ManualAdjustmentModal', 'mounted', 'Registering modal listener');
  eventBus.on('modal.credit-manual-adjustment.open', handleOpen);
});

onBeforeUnmount(() => {
  log('ManualAdjustmentModal', 'beforeUnmount', 'Removing modal listener');
  eventBus.off('modal.credit-manual-adjustment.open', handleOpen);
});
</script>
